import { InteractiveCTAOption, CTAButtonsValues } from 'types';
import { VAULT_FOLDER } from './constants';

export const sanitizePhoneForTel = (phone: string) => {
  if (!phone) return '';

  const match = phone.match(/^(.*?)(?:\s*ext\.?\s*(\d+))?$/i);
  if (!match) return phone.trim();

  const base = match[1].trim();
  const ext = match[2] || '';

  return `${base}${ext}`;
};

export const addCallToAction = (annotation: any) => {
  const props = {
    href: '',
    target: '_blank',
  };
  if (annotation?.linkType === 'Web' && annotation?.url) {
    props.href = annotation?.url;
  }

  if (annotation?.linkType === 'Email' && annotation?.email) {
    props.href = `mailto:${annotation?.email}`;
    props.target = 'mail';
  }

  if (annotation?.linkType === 'Phone' && annotation?.phone) {
    props.href = `tel:${sanitizePhoneForTel(annotation?.phone)}`;
  }

  return props;
};

export const onInteractiveCTAClick = (
  ctaItem: InteractiveCTAOption,
  setShowCtaVideoModal: Function
) => {
  if (ctaItem.type === CTAButtonsValues.EMAIL) {
    window.location.href = `mailto:${ctaItem.value}`;
    return;
  }
  if (ctaItem.type === CTAButtonsValues.VIDEO) {
    setShowCtaVideoModal(ctaItem?.linkValue || '');
    return;
  }
  const target = ctaItem.linkValue !== '' ? ctaItem.linkValue : ctaItem.value;
  window.open(target, '_blank');
};

export const getOverlayData = (url: string) => {
  let formattedUrl = url;
  let sandbox =
    'allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock allow-top-navigation allow-downloads';

  // Check if the URL starts with 'http://' and replace with 'https://'
  if (formattedUrl.startsWith('http://')) {
    formattedUrl = formattedUrl.replace('http://', 'https://');
  }

  // If the URL has no protocol (i.e., doesn't start with 'http://' or 'https://'), prepend 'https://'
  if (!formattedUrl.startsWith('https://')) {
    formattedUrl = `https://${formattedUrl}`;
  }

  if (url.includes('files.covideo.com')) {
    formattedUrl = formattedUrl.replace('files.covideo.com', 'd.pr');
  }
  // replace apostrophes
  formattedUrl = formattedUrl.replace("'", '%27');

  return {
    url: formattedUrl,
    sandbox,
  };
};

export enum InternalCustomers {
  COVIDEO = '3',
  AUTOMOTIVE = '50303',
  DEV = '54188',
  INTERNAL = '57316',
  FREEMIUM_DEV = '58410',
  FREEMIUM_PRODUCT = '58371',
  AUTOMOTIVE_LEADS_DEV = '55174',
  QA_COVIDEO = '63514',
  CDS_MARKETING = '1210',
}

export const isHtmlEmpty = (text: string) =>
  !text.replace(/<[^>]+>/g, '').trim();

export const isVaultVideoAlreadyViewed = (data: {
  video?: { folder: string | null };
  receiver?: { viewCount: number | null };
}): boolean => {
  const isVaultVideo = data?.video?.folder?.toLowerCase() === VAULT_FOLDER;
  const viewCount = data?.receiver?.viewCount || 0;
  return isVaultVideo && viewCount > 0;
};
